const LOCALE_MAP: Record<string, string> = {
  uk: "UK",
  de: "DE",
  au: "AU",
  ca_en: "CA_EN",
  ca_fr: "CA_FR",
};

export function normalizeFindModelLocale(...candidates: Array<string | null | undefined>): string {
  for (const candidate of candidates) {
    const raw = (candidate || "").trim();
    if (!raw) continue;
    const normalized = raw.replace("-", "_").toLowerCase();
    return LOCALE_MAP[normalized] || normalized.toUpperCase();
  }
  return "UK";
}
